module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario-290b133aa3d3cb6b81273f04ea02eb1e.png";